import IllustCard from "../IllustCard";
import "./Illusts.scoped.scss";
import illustsJson from "./illusts.json";
import { BackGroundType, CardInfo } from "../IllustCard/IllustCard";

interface Props {
  onClickIllust: (info: CardInfo) => void;
}

// JSONから読み取ったイラストの一覧をCardとして配置するコンポーネント
export default function Illusts(props: Props) {
  return (
    <div>
      {illustsJson.map((val, i) => (
        <IllustCard
          open={props.onClickIllust}
          key={val.twitterID}
          name={val.name}
          twitterID={val.twitterID}
          src={val.file}
          backgroundType={i % BackGroundType.Max}
        ></IllustCard>
      ))}
    </div>
  );
}
